interface MidPageCTAProps {
  variant?: 'primary' | 'secondary';
}

export default function MidPageCTA({ variant = 'primary' }: MidPageCTAProps) {
  const isPrimary = variant === 'primary';

  return (
    <section className="relative z-20 overflow-hidden">
      {isPrimary ? (
        // Primary: Full cinematic strip with background image
        <div className="relative py-20 md:py-24">
          <div
            className="absolute inset-0 bg-cover bg-center"
            style={{
              backgroundImage:
                'url(https://public.readdy.ai/ai/img_res/c9f7f97f804055fca5161de991c8b471.jpg)',
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-charcoal/95 via-charcoal/80 to-charcoal/50" />
          <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-8">
            <div className="max-w-2xl">
              <p className="text-[10px] tracking-[0.5em] uppercase text-gold mb-4">Exclusive Access</p>
              <h3 className="font-serif text-3xl md:text-5xl text-white font-light leading-tight mb-5">
                Ready to Explore Premier Lake Tahoe &amp;{' '}
                <em className="italic text-gold">Sierra Nevada</em> Properties?
              </h3>
              <p className="text-warm-white/60 text-sm leading-relaxed mb-8 max-w-lg">
                Gain access to exclusive listings, off-market opportunities, and expert alpine market intelligence — with a trusted local specialist by your side.
              </p>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <a
                  href="#consultation"
                  className="whitespace-nowrap px-8 py-4 bg-gold text-white text-[11px] tracking-[0.22em] uppercase font-medium cursor-pointer rounded-md hover:bg-[#b8983a] transition-all duration-300"
                  style={{ boxShadow: '0 0 30px rgba(196,169,98,0.3)' }}
                >
                  Request Private Consultation
                </a>
                <a
                  href="tel:5617146589"
                  className="whitespace-nowrap text-warm-white/70 text-sm hover:text-gold transition-colors cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-phone-line text-gold" />
                  561-714-6589
                </a>
              </div>
            </div>
          </div>
        </div>
      ) : (
        // Secondary: Striking dark strip with bold copy
        <div className="bg-charcoal py-16 md:py-20 px-4 md:px-8">
          {/* Gold accent line top */}
          <div className="w-full h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent mb-0 absolute left-0 right-0" style={{ marginTop: '-64px' }} />
          <div className="max-w-5xl mx-auto text-center">
            <p className="text-[10px] tracking-[0.5em] uppercase text-gold mb-4">Your Journey Begins Here</p>
            <h3 className="font-serif text-3xl md:text-5xl text-white font-light leading-tight mb-4">
              Let&apos;s Start Your Real Estate{' '}
              <em className="italic text-gold">Consultation</em>
            </h3>
            <p className="text-warm-white/50 text-sm max-w-lg mx-auto mb-8">
              Schedule a private session with Cam Kirkwood — no pressure, no obligation, just expert guidance and a strategy built around your goals.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="#consultation"
                className="whitespace-nowrap px-10 py-4.5 bg-gold text-white text-[11px] tracking-[0.22em] uppercase font-medium cursor-pointer rounded-md hover:bg-[#b8983a] transition-all duration-300"
                style={{ paddingTop: '1.125rem', paddingBottom: '1.125rem' }}
              >
                Schedule Now — It&apos;s Free
              </a>
              <div className="flex items-center gap-6">
                {['Buyer', 'Seller', 'Investor', 'Second Home'].map((label) => (
                  <span key={label} className="text-warm-white/30 text-[10px] tracking-[0.2em] uppercase">{label}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
